import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const sideBarSize = '5rem'
const sideBarSizeExpanded = '16rem'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    top: 0,
    left: 0,
    zIndex: 1000,
    position: 'fixed',
    width: sideBarSize,
    height: '100vh',
    backgroundColor: '#FFFFFF',
    transition: 'width 80ms ease-in',
    overflow: 'hidden',

    '&:hover': {
      width: sideBarSizeExpanded,
    },

    '& section': {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '100%',
      padding: '0.75rem',
      paddingTop: '0',
    },

    '& header': {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
      width: '100%',
      marginTop: '1rem',
    },

    '& main': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      width: '100%',
      height: '100%',
      gap: '1rem',
    },
  },

  rootExpanded: {
    width: sideBarSizeExpanded,
  },

  logo: {
    width: '3.5rem',
    height: '3rem',
    overflow: 'hidden',
  },

  logoExpanded: {
    width: '14rem',
    height: '3rem',
    overflow: 'hidden',
    textAlign: 'left',
  },
}))

export { useStyles }
